import React, { useState, useEffect } from "react";
import { func, string, bool } from "prop-types";
import { Formik, Form, Field } from "formik";
import { prop, equals } from "ramda";
import { Row, Col, Button } from "reactstrap";

import LegalEntityFormFields from "./legal-entity-form-fields";
import NaturalPersonFormFields from "./natural-person-form-fields";
import {
  FieldSpy,
  ButtonSelectType,
  Input,
  Select,
} from "../../../../components/formik";
import { optionsType, watchListEntryType } from "../../../../prop-types";
import {
  watchListLegalEntityEntryValidationSchema,
  watchListNaturalPersonEntryValidationSchema,
} from "../../validation-schemas";
import { selectInitialState } from "./initial-values";
import { ENTRY_TYPE } from "../../constants/watchListEntryConstants";

import "./upsertWatchListEntryForm.css";
import { PageTitle } from "../../../../components/common";
import FullscreenLoader from "../../../../layouts/FullScreenLoader";
import useRoles from "../../../../components/hooks/useRoles";

const UpsertWatchListEntryForm = ({
  handleSubmit,
  countries,
  nationalities,
  initialValues,
  disabledEntryTypeSelection,
  isLoading,
}) => {
  const { isCustomerSupport } = useRoles();
  const AdditionalFields = ({ isLegalEntity, ...props }) =>
    isLegalEntity ? (
      <LegalEntityFormFields countries={countries} {...props} />
    ) : (
      <NaturalPersonFormFields countries={countries} {...props} />
    );
  const [isLegalEntity, setIsLegalEntity] = useState(
    equals(ENTRY_TYPE.LEGAL_ENTITY, prop("type", initialValues))
  );

  const validationSchema = isLegalEntity
    ? watchListLegalEntityEntryValidationSchema
    : watchListNaturalPersonEntryValidationSchema;

  const [fields, setFields] = useState(
    <AdditionalFields
      isLegalEntity={isLegalEntity}
      nationalities={nationalities}
    />
  );

  const [selectedInitialValues, setSelectedInitialValues] = useState(
    initialValues || selectInitialState(initialValues, isLegalEntity)
  );

  useEffect(() => {
    setSelectedInitialValues(
      selectInitialState(selectedInitialValues, isLegalEntity)
    );
  }, [isLegalEntity]);

  useEffect(() => {
    setFields(
      <AdditionalFields
        isLegalEntity={isLegalEntity}
        nationalities={nationalities}
      />
    );
  }, [selectedInitialValues, nationalities]);

  const handleIsLegalEntityChange = (type) => {
    setIsLegalEntity(type === ENTRY_TYPE.LEGAL_ENTITY);
  };

  return (
    <Col className="terrorist-create-watchlist-form-container p-0 ">
      <PageTitle title="create eu terrorist watchlist entry" />
      <FullscreenLoader loading={isLoading} />
      <Formik
        enableReinitialize
        onSubmit={handleSubmit}
        initialValues={selectedInitialValues}
        validationSchema={validationSchema}
        validateOnBlur={false}
        validateOnChange={false}
      >
        <Form className="terrorist-create-watchlist-form pt-4">
          <Row>
            <Col lg={5}>
              <span className="css-changer">
                <Field
                  name="type"
                  label="Type"
                  className="dropdown-group"
                  options={[
                    { value: 1, label: "Natural person" },
                    { value: 2, label: "Legal entity" },
                  ]}
                  component={ButtonSelectType}
                  isDisabled={disabledEntryTypeSelection}
                />
              </span>

              <FieldSpy name="type" onChange={handleIsLegalEntityChange} />
            </Col>
            <Col lg={7} className="p-0">
              <Row>
                <Col lg={6} className="pr-0">
                  <Field
                    options={countries}
                    placeholder="Country"
                    name="addresses[0].countryId"
                    component={Select}
                  />
                </Col>
                <Col lg={6}>
                  <Field
                    placeholder="Region"
                    name="addresses[0].region"
                    component={Input}
                  />
                </Col>
              </Row>
            </Col>
          </Row>

          {fields}

          <Col className="text-center">
            <Button
              className="mt-3 save-button-terrorist mb-4 pl-5 pr-5"
              type="submit"
              disabled={isCustomerSupport}
            >
              Save
            </Button>
          </Col>
        </Form>
      </Formik>
    </Col>
  );
};

UpsertWatchListEntryForm.propTypes = {
  title: string.isRequired,
  handleSubmit: func.isRequired,
  countries: optionsType.isRequired,
  nationalities: optionsType.isRequired,
  initialValues: watchListEntryType,
  disabledEntryTypeSelection: bool,
};

export default UpsertWatchListEntryForm;



// WEBPACK FOOTER //
// ./src/features/watch-list-entry-eu-terrorists/components/upsert-watch-list-entry-form/UpsertWatchListEntryForm.jsx